import React, { useState, useRef, useEffect } from "react";
import { createPortal } from 'react-dom';
import { Tooltip } from './Tooltip';
import { findKeyBinding } from '../Menu/Menu';
export function getTooltipShortcut(id, bindings) {
    const key = findKeyBinding(id, bindings);
    return key ? `<code>${key}</code>` : '';
}
export function Tooltips({ children, delay, shortcuts }) {
    const ref = useRef(null);
    const [target, setTarget] = useState();
    useEffect(() => {
        setTarget(undefined);
        if (ref.current) {
            const timeouts = new Map();
            const show = (e) => {
                const target = e.target;
                timeouts.set(target, setTimeout(() => { setTarget(target); timeouts.delete(target); }, delay ?? 0));
            };
            const hide = (e) => {
                const target = e.target;
                clearTimeout(timeouts.get(target));
                timeouts.delete(target);
                setTarget(undefined);
            };
            ref.current.querySelectorAll('[data-tooltip]').forEach(el => {
                el.addEventListener('mouseenter', show);
                el.addEventListener('mouseleave', hide);
            });
            return () => {
                ref.current?.querySelectorAll('[data-tooltip]').forEach(el => {
                    el.removeEventListener('mouseenter', show);
                    el.removeEventListener('mouseleave', hide);
                });
            };
        }
    }, [children]);
    const getText = (target) => {
        let text = target.getAttribute('data-tooltip') ?? '';
        if (text.length && shortcuts && target.hasAttribute('data-command')) {
            text += getTooltipShortcut(target.getAttribute('data-command'), shortcuts);
        }
        return text;
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { ref: ref, style: { display: 'contents' } }, children),
        target && createPortal(React.createElement(Tooltip, { target: target, content: getText(target) }), document.body)));
}
